import React, { memo, useContext, useEffect, useState } from 'react';
import singleAxel from '../VehicleDiagrams/images1.png';
// import singleAxel from './VehicleDiagrams/images1.png';
import doubleAxelOne from '../VehicleDiagrams/axImage01.png';
import doubleAxelTwo from '../VehicleDiagrams/azImage02.png';
import doubleAxelThree from '../VehicleDiagrams/axImage03.png';
import Grid from '@material-ui/core/Grid';
import { TextBox as BaseSimpleField } from '../../../../Core/FormInput';
import { InputLabel, Typography, FormHelperText, withStyles } from '@material-ui/core';
import { InspectionCheCkContaxt } from './InspectionCheckProvide';

const style = {
    axOS: {
        marginTop: '45px',
        marginBottom: '-8px'
    },
    axOS2: {
        marginTop: '152px',
        marginBottom: '-8px'
    },
    ax2OS: {
        marginTop: '-17px',
        marginBottom: '-8px'
    },
    ax2OS2: {
        marginTop: '3px',
        marginBottom: '-8px'
    },
    ax2NS: { marginTop: '135px', marginBottom: '-8px' },
    ax2NSNew: { marginTop: '130px', marginBottom: '-8px' },
    ax2NSSingle: { marginTop: '145px', marginBottom: '-8px' },
    ax2Break: { marginBottom: '5px' },
    axBreakHeading: { textAlign: 'center' }
};

const GlobalCss = withStyles({
    '@global': {
        'input::-webkit-outer-spin-button, input::-webkit-inner-spin-button': {
            '-webkit-appearance': 'none',
            margin: 0
        }
    }
})(() => null);

const SimpleField = (props) => {
    const { state } = useContext(InspectionCheCkContaxt);
    const isReadOnly = Boolean(state.isDisabled || state.vehicleInspectionInspectorSignature);
    return <BaseSimpleField disabled={isReadOnly || props.disabled} {...props} />;
};

const Axel = memo((props) => {
    const { classes } = props;

    const { state, handleInspection, handleInputs, getPreviousTyreData } = useContext(InspectionCheCkContaxt);

    const getAxle = (num) => (state.inspectionSheetAxlesVM || []).find((a) => Number(a.axleNumber) === Number(num)) || {};

    const [show, setShow] = useState({
        showAxle1: false,
        showAxle2: false,
        showAxle3: false,
        showAxle4: false
    });

    let handleAxle = () => {
        let showAxle1 = false;
        let showAxle2 = false;
        let showAxle3 = false;
        let showAxle4 = false;
        if (state.vehicleNoOfAxles) {
            switch (state.vehicleNoOfAxles) {
                case 1:
                    showAxle1 = true;
                    break;
                case 2:
                    showAxle1 = true;
                    showAxle2 = true;
                    break;
                case 3:
                    showAxle1 = true;
                    showAxle2 = true;
                    showAxle3 = true;
                    break;
                case 4:
                    showAxle1 = true;
                    showAxle2 = true;
                    showAxle3 = true;
                    showAxle4 = true;
                    break;

                default:
                    break;
            }
        } else {
            showAxle1 = true;
            showAxle2 = true;
            showAxle3 = true;
            showAxle4 = true;
        }

        setShow((st) => ({
            ...st,
            showAxle1: showAxle1,
            showAxle2: showAxle2,
            showAxle3: showAxle3,
            showAxle4: showAxle4
        }));
    };

    useEffect(() => {
        handleAxle();
    }, [state.vehicleNoOfAxles]);

    return (
        <>
            <GlobalCss />
            <Grid container spacing={2} style={style.ax2Break} justify="center">
                {/* ..................Axel 1...................... */}
                {show.showAxle1 && (
                    <Grid item xs={12} sm={6} md={6} lg={3}>
                        <Grid item xs={12} sm={12}>
                            <h3 className={classes.axelTitles}>AXLE 1</h3>
                        </Grid>
                        <Grid item xs={12} sm={12}>
                            <Grid container justify="space-evenly" spacing={1}>
                                <Grid item xs={3}>
                                    <InputLabel shrink error style={style.axOS}>
                                        Depth*
                                    </InputLabel>
                                    <SimpleField
                                        type="number"
                                        placeholder="mm"
                                        name="osTreadDepth"
                                        onInput={(e) => {
                                            e.target.value = Math.max(0, parseInt(e.target.value)).toString().slice(0, 2);
                                        }}
                                        onChange={handleInputs(1)}
                                        value={getAxle(1)?.osTreadDepth}
                                    />
                                    <InputLabel shrink error style={style.axOS2}>
                                        Depth*
                                    </InputLabel>
                                    <SimpleField
                                        type="number"
                                        onInput={(e) => {
                                            e.target.value = Math.max(0, parseInt(e.target.value)).toString().slice(0, 2);
                                        }}
                                        placeholder="mm"
                                        name="nsTreadDepth"
                                        onChange={handleInputs(1)}
                                        value={getAxle(1)?.nsTreadDepth}
                                    />
                                </Grid>
                                <Grid item xs={4}>
                                    <InputLabel shrink error>
                                        Brakelining*
                                    </InputLabel>
                                    <SimpleField
                                        onInput={(e) => {
                                            if (e.target.value) {
                                                e.target.value = Math.max(0, parseInt(e.target.value)).toString().slice(0, 3);
                                            }
                                        }}
                                        type="number"
                                        placeholder="%"
                                        name="osBrakeLineRemaining"
                                        onChange={handleInputs(1)}
                                        value={getAxle(1)?.osBrakeLineRemaining || ''}
                                    />
                                    <img
                                        src={singleAxel}
                                        height="250px"
                                        width="100%"
                                        style={{
                                            marginTop: 5
                                        }}
                                    />
                                    <InputLabel shrink error>
                                        Brakelining*
                                    </InputLabel>
                                    <SimpleField
                                        onInput={(e) => {
                                            if (e.target.value) {
                                                e.target.value = Math.max(0, parseInt(e.target.value)).toString().slice(0, 3);
                                            }
                                        }}
                                        type="number"
                                        placeholder="%"
                                        name="nsBrakeLineRemaining"
                                        onChange={handleInputs(1)}
                                        value={getAxle(1)?.nsBrakeLineRemaining || ''}
                                    />
                                </Grid>
                                <Grid item xs={3}>
                                    <InputLabel shrink error style={style.axOS}>
                                        Pressure*
                                        {getAxle(1)?.osTyrePressure && (
                                            <b onClick={handleInspection} style={{ cursor: 'pointer', marginLeft: 4 }}>
                                                {'>>'}
                                            </b>
                                        )}
                                    </InputLabel>
                                    <SimpleField
                                        type="number"
                                        placeholder="psi"
                                        onInput={(e) => {
                                            e.target.value = Math.max(0, parseInt(e.target.value)).toString().slice(0, 3);
                                        }}
                                        name="osTyrePressure"
                                        onChange={handleInputs(1)}
                                        value={getAxle(1)?.osTyrePressure}
                                    />
                                    <InputLabel shrink error style={style.ax2NSSingle}>
                                        Pressure*
                                    </InputLabel>
                                    <SimpleField
                                        type="number"
                                        placeholder="psi"
                                        name="nsTyrePressure"
                                        onInput={(e) => {
                                            e.target.value = Math.max(0, parseInt(e.target.value)).toString().slice(0, 3);
                                        }}
                                        onChange={handleInputs(1)}
                                        value={getAxle(1)?.nsTyrePressure}
                                    />
                                </Grid>
                            </Grid>
                            <FormHelperText error style={{ textAlign: 'center' }}>
                                {state.errors?.axelone}
                            </FormHelperText>
                        </Grid>
                    </Grid>
                )}
                {/* ..................Axel 2 ..................... */}
                {show.showAxle2 && (
                    <Grid item xs={12} sm={6} md={6} lg={3}>
                        <h3 className={classes.axelTitles}>AXLE 2</h3>
                        <Grid item xs={12} sm={12}>
                            <Grid container xs={12} direction="row" justify="space-evenly" spacing={1}>
                                <Grid item xs={3}>
                                    <InputLabel shrink style={style.ax2OS} error>
                                        Depth*
                                    </InputLabel>
                                    <SimpleField
                                        type="number"
                                        onInput={(e) => {
                                            e.target.value = Math.max(0, parseInt(e.target.value)).toString().slice(0, 2);
                                        }}
                                        placeholder="mm"
                                        name="osTreadDepth"
                                        onChange={handleInputs(2)}
                                        value={getAxle(2)?.osTreadDepth}
                                    />
                                    <InputLabel shrink style={style.ax2OS2}>
                                        Depth
                                    </InputLabel>
                                    <SimpleField
                                        type="number"
                                        onInput={(e) => {
                                            e.target.value = Math.max(0, parseInt(e.target.value)).toString().slice(0, 2);
                                        }}
                                        placeholder="mm"
                                        name="osFrontTreadDepth"
                                        onChange={handleInputs(2)}
                                        value={getAxle(2)?.osFrontTreadDepth}
                                    />
                                    <InputLabel shrink style={style.ax2NS}>
                                        Depth
                                    </InputLabel>
                                    <SimpleField
                                        type="number"
                                        onInput={(e) => {
                                            e.target.value = Math.max(0, parseInt(e.target.value)).toString().slice(0, 2);
                                        }}
                                        placeholder="mm"
                                        name="nsFrontTreadDepth"
                                        onChange={handleInputs(2)}
                                        value={getAxle(2)?.nsFrontTreadDepth}
                                    />
                                    <InputLabel shrink style={style.ax2OS2} error>
                                        Depth*
                                    </InputLabel>
                                    <SimpleField
                                        type="number"
                                        onInput={(e) => {
                                            e.target.value = Math.max(0, parseInt(e.target.value)).toString().slice(0, 2);
                                        }}
                                        placeholder="mm"
                                        name="nsTreadDepth"
                                        onChange={handleInputs(2)}
                                        value={getAxle(2)?.nsTreadDepth}
                                    />
                                </Grid>
                                <Grid item xs={4}>
                                    <img src={doubleAxelOne} height="100px" width="100%" />
                                    <InputLabel shrink error style={style.axBreakHeading}>
                                        Brakelining*
                                    </InputLabel>
                                    <SimpleField
                                        onInput={(e) => {
                                            if (e.target.value) {
                                                e.target.value = Math.max(0, parseInt(e.target.value)).toString().slice(0, 3);
                                            }
                                        }}
                                        type="number"
                                        placeholder="%"
                                        name="osBrakeLineRemaining"
                                        onChange={handleInputs(2)}
                                        value={getAxle(2)?.osBrakeLineRemaining || ''}
                                    />
                                    <img src={doubleAxelTwo} height="45px" width="100%" />
                                    <InputLabel shrink error style={style.axBreakHeading}>
                                        Brakelining*
                                    </InputLabel>
                                    <SimpleField
                                        onInput={(e) => {
                                            if (e.target.value) {
                                                e.target.value = Math.max(0, parseInt(e.target.value)).toString().slice(0, 3);
                                            }
                                        }}
                                        type="number"
                                        placeholder="%"
                                        name="nsBrakeLineRemaining"
                                        onChange={handleInputs(2)}
                                        value={getAxle(2)?.nsBrakeLineRemaining || ''}
                                        style={style.ax2Break}
                                    />
                                    <img src={doubleAxelThree} height="100px" width="100%" />
                                </Grid>
                                <Grid item xs={3}>
                                    <InputLabel shrink style={style.ax2OS} error>
                                        Pressure*
                                    </InputLabel>
                                    <SimpleField
                                        type="number"
                                        onInput={(e) => {
                                            e.target.value = Math.max(0, parseInt(e.target.value)).toString().slice(0, 3);
                                        }}
                                        placeholder="psi"
                                        name="osTyrePressure"
                                        onChange={handleInputs(2)}
                                        value={getAxle(2)?.osTyrePressure}
                                    />
                                    <InputLabel shrink style={style.ax2OS2}>
                                        Pressure
                                    </InputLabel>
                                    <SimpleField
                                        type="number"
                                        onInput={(e) => {
                                            e.target.value = Math.max(0, parseInt(e.target.value)).toString().slice(0, 3);
                                        }}
                                        placeholder="psi"
                                        name="osFrontTyrePressure"
                                        onChange={handleInputs(2)}
                                        value={getAxle(2)?.osFrontTyrePressure}
                                    />
                                    <InputLabel shrink style={style.ax2NSNew}>
                                        Pressure
                                    </InputLabel>
                                    <SimpleField
                                        type="number"
                                        onInput={(e) => {
                                            e.target.value = Math.max(0, parseInt(e.target.value)).toString().slice(0, 3);
                                        }}
                                        placeholder="psi"
                                        name="nsFrontTyrePressure"
                                        onChange={handleInputs(2)}
                                        value={getAxle(2)?.nsFrontTyrePressure}
                                    />
                                    <InputLabel shrink style={style.ax2OS2} error>
                                        Pressure*
                                    </InputLabel>
                                    <SimpleField
                                        type="number"
                                        onInput={(e) => {
                                            e.target.value = Math.max(0, parseInt(e.target.value)).toString().slice(0, 3);
                                        }}
                                        placeholder="psi"
                                        name="nsTyrePressure"
                                        onChange={handleInputs(2)}
                                        value={getAxle(2)?.nsTyrePressure}
                                    />
                                </Grid>
                            </Grid>
                        </Grid>
                        <FormHelperText error style={{ textAlign: 'center' }}>
                            {state.errors?.axeltwo}
                        </FormHelperText>
                    </Grid>
                )}

                {/* ..................Axel 3 ..................... */}
                {show.showAxle3 && (
                    <Grid item xs={12} sm={6} md={6} lg={3}>
                        <h3 className={classes.axelTitles}>AXLE 3</h3>
                        <Grid item xs={12} sm={12}>
                            <Grid container xs={12} direction="row" justify="space-evenly" spacing={1}>
                                <Grid item xs={3}>
                                    <InputLabel shrink style={style.ax2OS}>
                                        Depth
                                    </InputLabel>
                                    <SimpleField
                                        type="number"
                                        onInput={(e) => {
                                            e.target.value = Math.max(0, parseInt(e.target.value)).toString().slice(0, 2);
                                        }}
                                        placeholder="mm"
                                        name="osTreadDepth"
                                        onChange={handleInputs(3)}
                                        value={getAxle(3).osTreadDepth}
                                    />
                                    <InputLabel shrink style={style.ax2OS2}>
                                        Depth
                                    </InputLabel>
                                    <SimpleField
                                        type="number"
                                        onInput={(e) => {
                                            e.target.value = Math.max(0, parseInt(e.target.value)).toString().slice(0, 2);
                                        }}
                                        placeholder="mm"
                                        name="osFrontTreadDepth"
                                        onChange={handleInputs(3)}
                                        value={getAxle(3).osFrontTreadDepth}
                                    />
                                    <InputLabel shrink style={style.ax2NS}>
                                        Depth
                                    </InputLabel>
                                    <SimpleField
                                        type="number"
                                        onInput={(e) => {
                                            e.target.value = Math.max(0, parseInt(e.target.value)).toString().slice(0, 2);
                                        }}
                                        placeholder="mm"
                                        name="nsFrontTreadDepth"
                                        onChange={handleInputs(3)}
                                        value={getAxle(3).nsFrontTreadDepth}
                                    />
                                    <InputLabel shrink style={style.ax2OS2}>
                                        Depth
                                    </InputLabel>
                                    <SimpleField
                                        type="number"
                                        onInput={(e) => {
                                            e.target.value = Math.max(0, parseInt(e.target.value)).toString().slice(0, 2);
                                        }}
                                        placeholder="mm"
                                        name="nsTreadDepth"
                                        onChange={handleInputs(3)}
                                        value={getAxle(3).nsTreadDepth}
                                    />
                                </Grid>
                                <Grid item xs={4}>
                                    <img src={doubleAxelOne} height="100px" width="100%" />
                                    <InputLabel shrink style={style.axBreakHeading}>
                                        Brakelining
                                    </InputLabel>
                                    <SimpleField
                                        onInput={(e) => {
                                            if (e.target.value) {
                                                e.target.value = Math.max(0, parseInt(e.target.value)).toString().slice(0, 3);
                                            }
                                        }}
                                        type="number"
                                        placeholder="%"
                                        name="osBrakeLineRemaining"
                                        onChange={handleInputs(3)}
                                        value={getAxle(3).osBrakeLineRemaining || ''}
                                    />
                                    <img src={doubleAxelTwo} height="45px" width="100%" />
                                    <InputLabel shrink style={style.axBreakHeading}>
                                        Brakelining
                                    </InputLabel>
                                    <SimpleField
                                        onInput={(e) => {
                                            if (e.target.value) {
                                                e.target.value = Math.max(0, parseInt(e.target.value)).toString().slice(0, 3);
                                            }
                                        }}
                                        type="number"
                                        placeholder="%"
                                        name="nsBrakeLineRemaining"
                                        onChange={handleInputs(3)}
                                        value={getAxle(3).nsBrakeLineRemaining || ''}
                                        style={style.ax2Break}
                                    />
                                    <img src={doubleAxelThree} height="100px" width="100%" />
                                </Grid>
                                <Grid item xs={3}>
                                    <InputLabel shrink style={style.ax2OS}>
                                        Pressure
                                    </InputLabel>
                                    <SimpleField
                                        type="number"
                                        onInput={(e) => {
                                            e.target.value = Math.max(0, parseInt(e.target.value)).toString().slice(0, 3);
                                        }}
                                        placeholder="psi"
                                        name="osTyrePressure"
                                        onChange={handleInputs(3)}
                                        value={getAxle(3).osTyrePressure}
                                    />
                                    <InputLabel shrink style={style.ax2OS2}>
                                        Pressure
                                    </InputLabel>
                                    <SimpleField
                                        type="number"
                                        onInput={(e) => {
                                            e.target.value = Math.max(0, parseInt(e.target.value)).toString().slice(0, 3);
                                        }}
                                        placeholder="psi"
                                        name="osFrontTyrePressure"
                                        onChange={handleInputs(3)}
                                        value={getAxle(3).osFrontTyrePressure}
                                    />
                                    <InputLabel shrink style={style.ax2NSNew}>
                                        Pressure
                                    </InputLabel>
                                    <SimpleField
                                        type="number"
                                        onInput={(e) => {
                                            e.target.value = Math.max(0, parseInt(e.target.value)).toString().slice(0, 3);
                                        }}
                                        placeholder="psi"
                                        name="nsFrontTyrePressure"
                                        onChange={handleInputs(3)}
                                        value={getAxle(3).nsFrontTyrePressure}
                                    />
                                    <InputLabel shrink style={style.ax2OS2}>
                                        Pressure
                                    </InputLabel>
                                    <SimpleField
                                        type="number"
                                        onInput={(e) => {
                                            e.target.value = Math.max(0, parseInt(e.target.value)).toString().slice(0, 3);
                                        }}
                                        placeholder="psi"
                                        name="nsTyrePressure"
                                        onChange={handleInputs(3)}
                                        value={getAxle(3).nsTyrePressure}
                                    />
                                </Grid>
                            </Grid>
                        </Grid>
                        <FormHelperText error style={{ textAlign: 'center' }}>
                            {state.errors?.axelthree}
                        </FormHelperText>
                    </Grid>
                )}

                {/* ..................Axel 4 ..................... */}
                {show.showAxle4 && (
                    <Grid item xs={12} sm={6} md={6} lg={3}>
                        <h3 className={classes.axelTitles}>AXLE 4</h3>
                        <Grid item xs={12} sm={12}>
                            <Grid container xs={12} direction="row" justify="space-evenly" spacing={1}>
                                <Grid item xs={3}>
                                    <InputLabel shrink style={style.ax2OS}>
                                        Depth
                                    </InputLabel>
                                    <SimpleField
                                        type="number"
                                        onInput={(e) => {
                                            e.target.value = Math.max(0, parseInt(e.target.value)).toString().slice(0, 2);
                                        }}
                                        placeholder="mm"
                                        name="osTreadDepth"
                                        onChange={handleInputs(4)}
                                        value={getAxle(4).osTreadDepth}
                                    />
                                    <InputLabel shrink style={style.ax2OS2}>
                                        Depth
                                    </InputLabel>
                                    <SimpleField
                                        type="number"
                                        onInput={(e) => {
                                            e.target.value = Math.max(0, parseInt(e.target.value)).toString().slice(0, 2);
                                        }}
                                        placeholder="mm"
                                        name="osFrontTreadDepth"
                                        onChange={handleInputs(4)}
                                        value={getAxle(4).osFrontTreadDepth}
                                    />
                                    <InputLabel shrink style={style.ax2NS}>
                                        Depth
                                    </InputLabel>
                                    <SimpleField
                                        type="number"
                                        onInput={(e) => {
                                            e.target.value = Math.max(0, parseInt(e.target.value)).toString().slice(0, 2);
                                        }}
                                        placeholder="mm"
                                        name="nsFrontTreadDepth"
                                        onChange={handleInputs(4)}
                                        value={getAxle(4).nsFrontTreadDepth}
                                    />
                                    <InputLabel shrink style={style.ax2OS2}>
                                        Depth
                                    </InputLabel>
                                    <SimpleField
                                        type="number"
                                        onInput={(e) => {
                                            e.target.value = Math.max(0, parseInt(e.target.value)).toString().slice(0, 2);
                                        }}
                                        placeholder="mm"
                                        name="nsTreadDepth"
                                        onChange={handleInputs(4)}
                                        value={getAxle(4).nsTreadDepth}
                                    />
                                </Grid>
                                <Grid item xs={4}>
                                    <img src={doubleAxelOne} height="100px" width="100%" />
                                    <InputLabel shrink style={style.axBreakHeading}>
                                        Brakelining
                                    </InputLabel>
                                    <SimpleField
                                        onInput={(e) => {
                                            if (e.target.value) {
                                                e.target.value = Math.max(0, parseInt(e.target.value)).toString().slice(0, 3);
                                            }
                                        }}
                                        type="number"
                                        placeholder="%"
                                        name="osBrakeLineRemaining"
                                        onChange={handleInputs(4)}
                                        value={getAxle(4).osBrakeLineRemaining || ''}
                                    />
                                    <img src={doubleAxelTwo} height="45px" width="100%" />
                                    <InputLabel shrink style={style.axBreakHeading}>
                                        Brakelining
                                    </InputLabel>
                                    <SimpleField
                                        onInput={(e) => {
                                            if (e.target.value) {
                                                e.target.value = Math.max(0, parseInt(e.target.value)).toString().slice(0, 3);
                                            }
                                        }}
                                        type="number"
                                        placeholder="%"
                                        name="nsBrakeLineRemaining"
                                        onChange={handleInputs(4)}
                                        value={getAxle(4).nsBrakeLineRemaining || ''}
                                        style={style.ax2Break}
                                    />
                                    <img src={doubleAxelThree} height="100px" width="100%" />
                                </Grid>
                                <Grid item xs={3}>
                                    <InputLabel shrink style={style.ax2OS}>
                                        Pressure
                                    </InputLabel>
                                    <SimpleField
                                        type="number"
                                        onInput={(e) => {
                                            e.target.value = Math.max(0, parseInt(e.target.value)).toString().slice(0, 3);
                                        }}
                                        placeholder="psi"
                                        name="osTyrePressure"
                                        onChange={handleInputs(4)}
                                        value={getAxle(4).osTyrePressure}
                                    />
                                    <InputLabel shrink style={style.ax2OS2}>
                                        Pressure
                                    </InputLabel>
                                    <SimpleField
                                        type="number"
                                        onInput={(e) => {
                                            e.target.value = Math.max(0, parseInt(e.target.value)).toString().slice(0, 3);
                                        }}
                                        placeholder="psi"
                                        name="osFrontTyrePressure"
                                        onChange={handleInputs(4)}
                                        value={getAxle(4).osFrontTyrePressure}
                                    />
                                    <InputLabel shrink style={style.ax2NSNew}>
                                        Pressure
                                    </InputLabel>
                                    <SimpleField
                                        type="number"
                                        onInput={(e) => {
                                            e.target.value = Math.max(0, parseInt(e.target.value)).toString().slice(0, 3);
                                        }}
                                        placeholder="psi"
                                        name="nsFrontTyrePressure"
                                        onChange={handleInputs(4)}
                                        value={getAxle(4).nsFrontTyrePressure}
                                    />
                                    <InputLabel shrink style={style.ax2OS2}>
                                        Pressure
                                    </InputLabel>
                                    <SimpleField
                                        type="number"
                                        onInput={(e) => {
                                            e.target.value = Math.max(0, parseInt(e.target.value)).toString().slice(0, 3);
                                        }}
                                        placeholder="psi"
                                        name="nsTyrePressure"
                                        onChange={handleInputs(4)}
                                        value={getAxle(4).nsTyrePressure}
                                    />
                                </Grid>
                            </Grid>
                        </Grid>
                        <FormHelperText error style={{ textAlign: 'center' }}>
                            {state.errors?.axelfour}
                        </FormHelperText>
                    </Grid>
                )}
                <Grid item xs={12}>
                    <FormHelperText error style={{ textAlign: 'center' }}>
                        {state.showTost ? state.axleErrors.message : ''}
                    </FormHelperText>
                </Grid>
            </Grid>
        </>
    );
});

export default Axel;
